import { Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { AccountService } from 'src/app/core/services/account.service';
import { Order } from '../../models/order';
import { VehicleType } from '../../models/vehicle';
import { OrderPreviewView } from './order-preview-state';
import { OrderService } from '../../services/order.service';
import { map, Subject, takeUntil } from 'rxjs';

export type OrderPreviewData = {
  orderNumber: number;
  order: Order;
}

@Component({
  templateUrl: './order-preview.component.html',
  styleUrls: ['./order-preview.component.scss'],
})
export class OrderPreviewComponent implements OnInit, OnDestroy {
  readonly OrderPreviewView: typeof OrderPreviewView = OrderPreviewView;
  @Input({ required: true }) data!: OrderPreviewData;
  private destroy$ = new Subject<void>();
  account$ = this.accountService.account$;
  currentView: OrderPreviewView = OrderPreviewView.Overview;
  hasClickedExtraInfo = false;

  constructor(
    private accountService: AccountService,
    private orderService: OrderService
  ) { }

  ngOnInit(): void {
    this.orderService.orders$
      .pipe(
        map((orders) => orders.find((o) => o.id === this.data.order.id)),
        takeUntil(this.destroy$)
      )
      .subscribe((order) => {
        if (order) {
          this.data.order = order;
        }
      });
  }

  changeView(view: OrderPreviewView): void {
    if (view === OrderPreviewView.ExtraInfo) {
      this.hasClickedExtraInfo = true;
    }
    this.currentView = view;
  }

  getVehicleIcon(vehicleType: VehicleType): string {
    switch (vehicleType) {
      case VehicleType.Car:
        return "../../assets/icon/car.svg"
      case VehicleType.Bicycle:
        return "../../assets/icon/bicycle.svg"
      case VehicleType.MotorCycle:
        return "../../assets/icon/motorcycle.svg"
      default:
        return "../../assets/icon/car.svg"
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
